import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ManageMobileLanguage from './ManageMobileLanguage';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, intl, params }) {

    const title = intl?.formatMessage(messages.mobileLanguagePageTitle);
    const isAdminAuthenticated = store?.getState()?.runtime?.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    const privileges = store.getState().listSettings && store.getState().listSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    if (!restrictUrls('/siteadmin/mobile-language', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout><ManageMobileLanguage title={title} appType={params?.appType} /></AdminLayout>,
    };
}
